import * as React from 'react';

import {ActionMenu} from 'shells/action-menu/action-menu';
import {Dialog} from 'shells/dialog/dialog';
import {EditIcon, TrashIcon, SidebarIconReportsIconOld} from 'shells/icon';

import {appHistory} from '../../../history';

type Props = {
    reportUrl: string;
    canDelete: boolean;
    onEditActivityType: () => void;
    onDeleteActivityType: () => void;
};

export function ActivityTypesRowActionMenu(props: Props) {
    const {canDelete, reportUrl, onEditActivityType} = props;

    const [isConfirmingDelete, setIsConfirmingDelete] = React.useState<boolean>(false);
    const actionMenuRef = React.useRef();

    const actionMenuOptions = React.useMemo(() => {
        const options = [
            {
                label: 'Activity report',
                handleSelect: () => appHistory.push(reportUrl),
                icon: <SidebarIconReportsIconOld size={16} />,
            },
            {
                label: 'Edit activity',
                handleSelect: onEditActivityType,
                icon: <EditIcon size={16} />,
            },
        ];
        if (canDelete) {
            options.push({
                label: 'Delete activity',
                handleSelect: () => setIsConfirmingDelete(true),
                icon: <TrashIcon size={16} />,
                // @ts-expect-error
                variant: 'destructive',
            });
        }

        return options;
    }, [canDelete, reportUrl, onEditActivityType]);

    return (
        <>
            <ActionMenu
                options={actionMenuOptions}
                getRef={(node) => {
                    // @ts-expect-error
                    actionMenuRef.current = node;
                }}
                size='small'
                hasHoverBackground={true}
            />
            {isConfirmingDelete ? (
                <Dialog
                    anchor={actionMenuRef.current}
                    question='Are you sure you want to delete this activity type?'
                    isWarning={true}
                    primaryText='Delete'
                    secondaryText='Cancel'
                    onSecondary={() => setIsConfirmingDelete(false)}
                    onPrimary={() => {
                        setIsConfirmingDelete(false);
                        props.onDeleteActivityType();
                    }}
                />
            ) : undefined}
        </>
    );
}
